import { useCallback } from 'react';
// @ts-expect-error Not typed yet
import TinyMcePopover from './TinyMcePopover';
import { getAtomValue, useAtomValue } from '../data/atomUtils';
import { hsContentAssistanceSelectedCommandAtom, setHsContentAssistanceCommand } from '../data/contentAssistanceAtoms';
import { removeAutocompleteSpanTarget, getAutocompleteSpan
// @ts-expect-error Not typed yet
} from '../hsautocomplete/utils';
import { getAnnotatedSelectionContextAsPlainText, getAnnotatedSelectionContextAsPlainTextAndRemovePrecedingSlashCommand } from '../utils/dom';
import { trackInteraction } from '../utils/usageTracking';
import { CONTENT_GENERATION_INLINE_EDIT_INTERACTION, CONTENT_GENERATION_SLASH_COMMAND_ACTION_TYPE } from '../constants/usageTracking';
import { autocompleteActiveRangeAtom, closeAutocompleteResultPopover, useIsAutocompleteResultPopoverOpen
// @ts-expect-error Not typed yet
} from '../data/autocompleteAtoms';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentAssistanceAutocompletePopoverManager({
  brandVoiceOptions,
  editor,
  insertContent,
  InlineAutocompleteMenu
}) {
  const selectedCommand = useAtomValue(hsContentAssistanceSelectedCommandAtom);
  const isAnyAutocompletePopoverOpen = useIsAutocompleteResultPopoverOpen(editor);
  const isHighlightingText = editor.selection && !editor.selection.isCollapsed();
  const handleTrackInteraction = useCallback((action, props = {}, eventKey = CONTENT_GENERATION_INLINE_EDIT_INTERACTION) => {
    const meta = Object.assign({
      actionType: CONTENT_GENERATION_SLASH_COMMAND_ACTION_TYPE
    }, props);
    trackInteraction(editor, eventKey, action, meta);
  }, [editor]);
  const handleRemove = () => {
    setHsContentAssistanceCommand(null);
    removeAutocompleteSpanTarget(editor);
    closeAutocompleteResultPopover();
  };
  const onComplete = generatedText => {
    insertContent(generatedText);
    handleRemove();
  };
  const isOpen = Boolean(selectedCommand) && isAnyAutocompletePopoverOpen;
  let editorContext = '';
  const range = getAtomValue(autocompleteActiveRangeAtom);
  if (isOpen) {
    // Highlight command - opened from TinyMcE dropdown
    if (isHighlightingText) {
      editorContext = getAnnotatedSelectionContextAsPlainText(editor, range);
      // Slash command
    } else {
      editorContext = getAnnotatedSelectionContextAsPlainTextAndRemovePrecedingSlashCommand(editor, range);
    }
  }

  // getAutocompleteSpan bases target off of getAutocompleteSpan
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    placement: "bottom right",
    editor: editor,
    open: isOpen,
    animateOnToggle: false,
    use: "unstyled",
    onRemove: handleRemove,
    target: getAutocompleteSpan(),
    renderContent: () => /*#__PURE__*/_jsx(InlineAutocompleteMenu, {
      brandVoiceOptions: brandVoiceOptions,
      currentCommand: selectedCommand,
      editorContext: editorContext,
      onPromptComplete: onComplete,
      trackInteraction: handleTrackInteraction,
      onClose: handleRemove
    })
  });
}